import { Injectable } from "@angular/core";
import * as moment from "moment-timezone";
import { SignalBoConfiguration } from "../../shared/configuration/SignalBoConfiguration";

@Injectable()
export class ValidationsService {
  constructor(private _signalBoConfiguration: SignalBoConfiguration) {}

  public validateRequired(message): boolean {
    return (
      message.content.title &&
      (message.content.imageUrl || message.content.description)
    );
  }

  public validateCategory(message): boolean {
    return (
      (message.content.category !== "Analysis" &&
        message.content.category !== "Education") ||
      message.content.authorId
    );
  }

  public validateMediaLink(message): boolean {
    return !message.content.imageUrl || message.content.mediaLink;
  }

  public validateScheduledDate(date): boolean {
    return date > moment.utc();
  }

  public validateTags(message): boolean {
    return message.content.tags.length > 0;
  }

  public hasInvalidLimits(
    side: string,
    stopLoss?: number,
    takeProfit?: number,
    entryPrice?: number
  ): boolean {
    if (!takeProfit && !stopLoss)
      return false;

    takeProfit = takeProfit || entryPrice || stopLoss;
    stopLoss = stopLoss || entryPrice || takeProfit;
    entryPrice = entryPrice || stopLoss;

    function isInvalidBuy() {
      return side == "BUY" && (takeProfit < entryPrice || entryPrice < stopLoss);
    }
    function isInvalidSell() {
      return side == "SELL" && (takeProfit > entryPrice || entryPrice > stopLoss);
    }

    var result = isInvalidBuy() || isInvalidSell();
   
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/tradingstudio/services/validations.service.ts